import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service4_1.jpeg';

const overview = [
  'Enterprise grade Servers for AI developments, Storage, Powerful Workstations, Network Switches, APs, End Compute Devices & MFDs.',
  'Procurement and deployment services for organisations of all sizes.',
  'Strong partnership & relationship with Globally renowned brands enable us to deliver best in class products with committed Services & Support through out the life cycle.',
  'World Class Products that can provide best of Total cost of ownership (TCO) & Return on Investment (ROI).',
  'Best in class products supply, Installation & custom configuration to suit each business needs.',
  'Hand holding the customer from procurement, configuration, application, usage till refresh or e-waste.'
];

const features = [
  { title: 'Servers & Storage', text: "Right Enterprise devices & technologies to suit customer's business." },
  { title: 'End Compute',       text: 'Products and tools with Power & Cutting edge technologies to enhance productivity and end user experience.' },
  { title: 'Peripherals',       text: 'Multifunction devices which can Print, Scan, Copy, Fax & Digital send the documents at ease and secure.' },
  { title: 'Deployment',        text: 'Professional installation and configuration, implementation of right tools to boost productivity.' }
];

function HardwareService() {
  return (
    <ServicePage
      title="IT Hardware Solution"
      subtitle="Enterprise-grade hardware for your business"
      img={img}
      imgAlt="IT Hardware"
      overview={overview}
      features={features}
      backAnchor="hardware"
    />
  );
}

export default HardwareService;
